import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class IronMountainsTerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.IRON_MOUNTAINS;
}

export default IronMountainsTerrainTileEntity;
